import { Box, Spinner, useToggle } from '@factorialco/deprecated-design-system'

import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import type { IncidenceTaskDocument } from 'modules/bookkeepers/hooks/useGetIncidenceTaskDocuments'
import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'

import DeleteModal from './DeleteModal'
import DocumentCard from './DocumentCard'

interface Props {
  onDocumentDrop: (files: File[]) => void
  onDelete: (documentId: string) => void
  document?: IncidenceTaskDocument
  deleting?: boolean
  creating?: boolean
}

const TaskDocument = ({
  onDocumentDrop,
  onDelete,
  document,
  deleting = false,
  creating = false,
}: Props) => {
  const [isOpen, setIsOpen] = useToggle(false)

  return (
    <>
      <Box
        padding="s12"
        borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
        background="grey100"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey200',
          },
        }}
      >
        {creating ? (
          <Box width="full" alignItems="center">
            <Spinner />
          </Box>
        ) : document ? (
          <>
            {isOpen && (
              <DeleteModal
                onClose={setIsOpen(false)}
                onDelete={() => onDelete(document.id)}
                deleting={deleting}
              />
            )}
            <DocumentCard document={document} disabled={deleting} onDelete={setIsOpen(true)} />
          </>
        ) : (
          <DropzoneBox
            message={i18n.t('documents.drop_here')}
            multiple={false}
            accept={acceptedContentTypes()}
            onDrop={onDocumentDrop}
          />
        )}
      </Box>
    </>
  )
}

export default TaskDocument
